export const webSocketConstants = {
    VALID: 'VALID',
    NOT_VALID: 'NOT_VALID',
    VERIFYING: 'VERIFYING',
    SET_DATA: 'WEB_SOCKET_SET_DATA',
    CLEAN_REDUCER: 'WEB_SOCKET_CLEAN_REDUCER',
    BLUEPRINT_STATE: 'BLUEPRINT_STATE',
    BLUEPRINT_LIFECYCLE: 'BLUEPRINT_LIFECYCLE'
};
